import z from 'zod';
export const additionalProductPurchaseSessionIdValue = z
    .string()
    .trim()
    .min(1)
    .brand('AdditionalProductPurchaseSessionId');
export const createAdditionalProductPurchaseSessionId = (value) => additionalProductPurchaseSessionIdValue.parse(value);
export const isAdditionalProductPurchaseSessionId = (value) => additionalProductPurchaseSessionIdValue.safeParse(value).success;
/** No id-generation port is defined by the domain spec for this internal
 * PK (cf. `AdditionalProductPurchaseSessionRepository` — `save` takes an
 * already-identified session) — a lightweight UUID v4 is generated here,
 * without relying on a runtime `crypto` global unavailable in this
 * package's TypeScript lib target. */
export function createRandomAdditionalProductPurchaseSessionId() {
    const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    const uuid = template.replaceAll(/[xy]/g, character => {
        const randomValue = Math.trunc(Math.random() * 16);
        const value = character === 'x'
            ? randomValue
            : (randomValue & 0x3) | 0x8;
        return value.toString(16);
    });
    return createAdditionalProductPurchaseSessionId(uuid);
}
export const ADDITIONAL_PRODUCT_PURCHASE_MODE_CHECKOUT = 'checkout';
export const ADDITIONAL_PRODUCT_PURCHASE_MODE_DIRECT = 'direct';
export const additionalProductPurchaseModeValue = z.enum([
    ADDITIONAL_PRODUCT_PURCHASE_MODE_CHECKOUT,
    ADDITIONAL_PRODUCT_PURCHASE_MODE_DIRECT,
]);
//# sourceMappingURL=additional-product-purchase-session.js.map